import { render } from "./LayoutsAuthPcHeader.vue?vue&type=template&id=bd7da7ce&scoped=true&ts=true"
import script from "./LayoutsAuthPcHeader.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthPcHeader.vue?vue&type=script&lang=ts"

import "./LayoutsAuthPcHeader.vue?vue&type=style&index=0&id=bd7da7ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7da7ce"]])

export default __exports__